import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TendenciaPerdidaComponent } from './tendencia-perdida/tendencia-perdida.component';
import { authGuardSubmodule } from '../../auth/auth.guard';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { MatrizTransicionComponent } from './matriz-transicion/matriz-transicion.component';
import { CosechasComponent } from './cosechas/cosechas.component';
import { ConcentracionComponent } from './concentracion/concentracion.component';
import { MayoresDeudoresComponent } from './mayores-deudores/mayores-deudores.component';
import { ReporteComponent } from './reporte/reporte.component';
import { MayoresDeudoresAComponent } from './mayores-deudores-a/mayores-deudores-a.component';
import { ConcentracionAComponent } from './concentracion-a/concentracion-a.component';
import { CoberturaComponent } from './cobertura/cobertura.component';
import { ReservaCarteraComponent } from './reserva-cartera/reserva-cartera.component';

const routes: Routes = [{
  path: 'app/riesgo-credito',
    component: ContenedorComponent,
    children: [
      {path: 'tendencia-perdida', component: TendenciaPerdidaComponent, canActivate: [authGuardSubmodule]},
      {path: 'matriz-transicion', component: MatrizTransicionComponent, canActivate: [authGuardSubmodule]},
      {path: 'cosechas', component: CosechasComponent, canActivate: [authGuardSubmodule]},
      {path: 'concentracion', component: ConcentracionComponent, canActivate: [authGuardSubmodule]},
      {path: 'mayores-deudores', component: MayoresDeudoresComponent, canActivate: [authGuardSubmodule]},
      {path: 'reporte', component: ReporteComponent, canActivate: [authGuardSubmodule]},
      {path: 'mayores-deudoresAT', component: MayoresDeudoresAComponent, canActivate: [authGuardSubmodule]},
      {path: 'concentracionAT', component: ConcentracionAComponent, canActivate: [authGuardSubmodule]},
      {path: 'cobertura', component: CoberturaComponent, canActivate: [authGuardSubmodule]},
      {path: 'reserva-cartera', component: ReservaCarteraComponent, canActivate: [authGuardSubmodule]}
    ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RiesgoCreditoRoutingModule { }
